// extracted by mini-css-extract-plugin
module.exports = {"root":"checkbox-group_root__Gbe3x","orientationvertical":"checkbox-group_orientationvertical__xs1Xj","orientationhorizontal":"checkbox-group_orientationhorizontal__4RCqX"};